/*
 * Invoo logo — reconstructed as inline SVG exactly from the prototype
 * (Invoo.dc.html, viewBox 0 0 40 42 / 0 0 52 32). DESIGN.md §1:
 * orange check (#F97316) detached from the "I"; "Inv" in Nunito ExtraBold;
 * violet infinity (#6D28D9) forming the "oo", recentred top:0.08em.
 * `dark` variant: white text + lilac (#a78bfa) infinity for the sidebar.
 */
export default function Logo({ size = 27, dark = false, className, onClick }) {
  const textColor = dark ? '#ffffff' : '#2a1a4a'
  const infinityColor = dark ? '#a78bfa' : '#6D28D9'
  return (
    <span
      onClick={onClick}
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontFamily: "'Nunito', sans-serif",
        fontWeight: 800,
        color: textColor,
        letterSpacing: '-.02em',
        fontSize: size,
        lineHeight: 1,
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
      }}
    >
      <svg width="0.95em" height="1em" viewBox="0 0 40 42" fill="none" style={{ marginRight: '0.05em', flex: 'none' }}>
        <path d="M7 21 L16 31 L37 6" stroke="#F97316" strokeWidth="6.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      Inv
      <svg
        width="1.18em"
        height="0.73em"
        viewBox="0 0 52 32"
        fill="none"
        style={{ marginLeft: '-0.05em', position: 'relative', top: '0.08em', flex: 'none' }}
      >
        <path
          d="M26 16 C26 5 7 5 7 16 C7 27 26 27 26 16 C26 5 45 5 45 16 C45 27 26 27 26 16 Z"
          stroke={infinityColor}
          strokeWidth="5.8"
        />
      </svg>
    </span>
  )
}
